'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { FC, ReactNode, useEffect } from 'react';
import { useSession } from 'next-auth/react';

type PostHogProviderWrapperProps = {
  children: ReactNode;
};

export const PostHogProvider: FC<PostHogProviderWrapperProps> = ({ children }) => {
  const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const { data: session } = useSession();

  useEffect(() => {
    if (typeof window !== 'undefined' && !!POSTHOG_KEY) {
      posthog.init(POSTHOG_KEY, {
        api_host: 'https://us.i.posthog.com',
        session_recording: { maskAllInputs: false },
        autocapture: true,
      });
    }
  }, [POSTHOG_KEY]);

  useEffect(() => {
    if (session?.user?.id) {
      posthog.identify(session.user.id, {
        email: session.user.email,
        name: session.user.name,
      });
    }
  }, [session]);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};
